const DOMAIN = "https://d363r49np5tk98.cloudfront.net/";
const BUCKET = "hautesociete-user-photos-v2";

/**
 * @description Serverless Image Handler
 * @url https://d2qnb1baxbnyux.cloudfront.net/index.html
 */
export const SIH_URL = ({ key }: { key: string }, size?: number, smartCrop?: boolean) => {
  const request = {
    key,
    bucket: BUCKET,
    edits: {},
  };

  if (size) {
    request.edits = {
      ...request.edits,
      resize: {
        width: size,
        height: size,
        fit: "cover",
      },
    };
  }
  if (smartCrop) {
    request.edits = {
      ...request.edits,
      smartCrop: {
        padding: 130,
      },
    };
  }

  const strRequest = JSON.stringify(request);
  const encRequest = btoa(strRequest);

  return `${DOMAIN}${encRequest}`;
};
